import ColescbaApp from '@colescba/app-vue'
import ColescbaAuthVue from '@colescba/auth-vue'
import ColescbaUI from '@colescba/ui'

// caracteristicas habilitadas
const features = {
  delegacion: false,
  notificaciones: true,
  padAplicaciones: true,
}

// plugins a instalar
const plugins = {
  auth: ColescbaAuthVue,
  ui: ColescbaUI,
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.use(ColescbaApp, { env: process.env, plugins, features })
  },
}
